import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_ClientDischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_ClientDischargeSummary' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><center><h3>CLIENT DISCHARGE ASSESSMENT</h3></center></p>
                <p className='w-750'><span className='eleHeader'>Reason for Admission (Chief Complaint):</span>
                    <textarea id='txtReasonForAdmission' name='txtReasonForAdmission' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Discharge/Termination: </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbReasonForDischarge_1' name='rbReasonForDischarge' className='add-only' value='1' /> Discharged as planned</td>
                        <td className='w-250'>
                            <input type='radio' id='rbReasonForDischarge_2' name='rbReasonForDischarge' className='add-only' value='2' /> Have missed excessive appointments</td>
                        <td className='w-250'>
                            <input type='radio' id='rbReasonForDischarge_3' name='rbReasonForDischarge' className='add-only' value='3' /> Insufficient progress in therapy</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbReasonForDischarge_4' name='rbReasonForDischarge' className='add-only' value='4' /> No longer making appointments</td>
                        <td className='w-250'>
                            <input type='radio' id='rbReasonForDischarge_5' name='rbReasonForDischarge' className='add-only' value='5' /> Referred for other services</td>
                        <td className='w-250'>
                            <input type='radio' id='rbReasonForDischarge_6' name='rbReasonForDischarge' className='add-only' value='6' /> Terminated against therapist's advice</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbReasonForDischarge_7' name='rbReasonForDischarge' className='add-only' value='7' /> Other &nbsp;
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-650 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Was client in agreement with termination at time of discharge: </span>
                    <input type='radio' id='rbWasClientInAgreementWithTerminationAtTime_Yes' name='rbWasClientInAgreementWithTerminationAtTime' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbWasClientInAgreementWithTerminationAtTime_No' name='rbWasClientInAgreementWithTerminationAtTime' className='add-only' value='No' /> No</p>

                <p className='w-750'><span className='eleHeader'>Service Provided:</span>
                    <input type='radio' id='rbServiceProvided_Adult' name='rbServiceProvided' className='add-only' value='Adult' /> PRP-Adult &nbsp;&nbsp;
                    <input type='radio' id='rbServiceProvided_Minor' name='rbServiceProvided' className='add-only' value='Minor' /> PRP-Minor&nbsp;&nbsp;
                    <input type='radio' id='rbServiceProvided_Medication' name='rbServiceProvided' className='add-only' value='Medication' /> Medication Management&nbsp;&nbsp;
                    <input type='radio' id='rbServiceProvided_Therapy' name='rbServiceProvided' className='add-only' value='Therapy' /> Therapy/ Counseling&nbsp;&nbsp;
                    <input type='radio' id='rbServiceProvided_SubstanceAbuse' name='rbServiceProvided' className='add-only' value='SubstanceAbuse' /> Substance Abuse</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Frequency of Sessions at time of discharge:</span></td>


                        <td className='w-375'>
                            <span className='eleHeader'>DSM-V Diagnosis at discharge:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFrequencyOfSessions' name='txtFrequencyOfSessions' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtDiagnosisAtDischarge' name='txtDiagnosisAtDischarge' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Active in Therapy:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Therapist Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbActiveInTherapy_Yes' name='rbActiveInTherapy' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;
                            <input type='radio' id='rbActiveInTherapy_No' name='rbActiveInTherapy' className='add-only' value='No' /> No&nbsp;&nbsp;</td>

                        <td className='w-375'>
                            <input type='text' id='txtTherapistName' name='txtTherapistName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Currently Prescribed Medications</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescriber Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbCurrentyPrescribedMedication_Yes' name='rbCurrentyPrescribedMedication' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;
                            <input type='radio' id='rbCurrentyPrescribedMedication_No' name='rbCurrentyPrescribedMedication' className='add-only' value='No' /> No&nbsp;&nbsp;</td>

                        <td className='w-375'>
                            <input type='text' id='txtPrescriberName' name='txtPrescriberName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Medications</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCurrentMedications' name='txtCurrentMedications' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>
                    Treatment Goals</span>
                    Goal #1:<input type='text' id='txtTreatmentGoals_1' name='txtTreatmentGoals_1' className='add-only w-650 custom-add-only' /><br />
                    Goal #2:<input type='text' id='txtTreatmentGoals_2' name='txtTreatmentGoals_2' className='add-only w-650 custom-add-only' /><br />
                    Goal #3:<input type='text' id='txtTreatmentGoals_3' name='txtTreatmentGoals_3' className='add-only w-650 custom-add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Progress Made:</span>
                    <input type='radio' id='rbProgressMade_Marked' name='rbProgressMade' className='add-only' value='Marked' /> Marked Improvement &nbsp;&nbsp;
                    <input type='radio' id='rbProgressMade_Moderate' name='rbProgressMade' className='add-only' value='Moderate' /> Moderate Improvement&nbsp;&nbsp;
                    <input type='radio' id='rbProgressMade_Minor' name='rbProgressMade' className='add-only' value='Minor' /> Minor Improvement&nbsp;&nbsp;
                    <input type='radio' id='rbProgressMade_Regressed' name='rbProgressMade' className='add-only' value='Regressed' /> Regressed&nbsp;&nbsp;
                </p>

                <p className='w-750'><h4>Continuing Service Recommendation</h4></p>

                <p className='w-750'><span className='eleHeader'>Recommendation #1</span>
                    <input type='text' id='txtRecommendation_1' name='txtRecommendation_1' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>Recommendation #2</span>
                    <input type='text' id='txtRecommendation_2' name='txtRecommendation_2' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>Safety Concerns Present:</span>
                    <input type='text' id='txtSafetyConcernsPresent' name='txtSafetyConcernsPresent' className='add-only' /></p>

                <p className='w-750'>
                    <span className='eleHeader'>Summary of the transition process</span>
                    <span className='small'>(include referrals made; new service providers, step-down service
                        etc.):</span>
                    <textarea id='txtSummaryOfTheTransition' name='txtSummaryOfTheTransition' className='add-only'></textarea></p>

                <p className='w-750'><h4>Client Signature:</h4></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Signature</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtSignature_2' name='txtSignature_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='Date' id='txtDate_3' name='txtDate_3' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>*If client is unable to sign or provided verbal consent to sign, please indicate below:</b> <br />
                    <input type='radio' id='rbIfClientIsUnableToSignOrProvided_1' name='rbIfClientIsUnableToSignOrProvided' className='add-only' value='Verbal' /> Verbal Consent to Sign &nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbIfClientIsUnableToSignOrProvided_2' name='rbIfClientIsUnableToSignOrProvided' className='add-only' value='Refused' /> Refused to Sign&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbIfClientIsUnableToSignOrProvided_3' name='rbIfClientIsUnableToSignOrProvided' className='add-only' value='Unable' /> Unable to Locate Client to Sign</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Title/ Credentials</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_2' name='txtName_2' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTitleCredentials' name='txtTitleCredentials' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Signature </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSignature_3' name='txtSignature_3' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate_4' name='txtDate_4' className='add-only' /></td>

                    </tr>
                </table>




                
            </div>
        </form>
    )
}